function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  key: 1,
  id: "sideModal",
  class: "side-modal"
};
var _hoisted_2 = {
  class: "side-modal-content"
};
var _hoisted_3 = {
  class: "side-modal-header"
};
var _hoisted_4 = {
  key: 0,
  class: "loading-container"
};
var _hoisted_5 = {
  key: 1
};
var _hoisted_6 = {
  class: "menu-tabs"
};
var _hoisted_7 = {
  key: 0
};
var _hoisted_8 = {
  key: 1
};
var _hoisted_9 = {
  class: "tab-content-side"
};
var _hoisted_10 = {
  key: 0
};
var _hoisted_11 = {
  class: "side-modal-button-group"
};
var _hoisted_12 = {
  key: 0,
  class: "side-modal-button-group"
};
var _hoisted_13 = {
  class: "side-modal-button-group"
};
var _hoisted_14 = {
  class: "side-modal-news"
};
var _hoisted_15 = {
  class: "side-modal-news-button-wrapper"
};
var _hoisted_16 = {
  key: 1
};
var _hoisted_17 = {
  class: "side-modal-button-group"
};
var _hoisted_18 = {
  key: 0,
  class: "side-modal-button-group"
};
var _hoisted_19 = {
  key: 1,
  class: "side-modal-button-group"
};
var _hoisted_20 = {
  class: "side-modal-news"
};
var _hoisted_21 = {
  key: 2
};
var _hoisted_22 = {
  class: "side-modal-button-group"
};
var _hoisted_23 = {
  key: 0,
  class: "side-modal-button-group"
};
var _hoisted_24 = {
  key: 1,
  class: "side-modal-button-group"
};
var _hoisted_25 = {
  class: "side-modal-news"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_v_rounded_button = _resolveComponent("v-rounded-button");
  var _component_v_svg_icon_cross = _resolveComponent("v-svg-icon-cross");
  var _component_v_loading_spinner_with_text = _resolveComponent("v-loading-spinner-with-text");
  var _component_v_svg_icon_three_houses = _resolveComponent("v-svg-icon-three-houses");
  var _component_v_svg_icon_house_with_car = _resolveComponent("v-svg-icon-house-with-car");
  var _component_v_svg_icon_house_with_tree = _resolveComponent("v-svg-icon-house-with-tree");
  var _component_v_svg_icon_line_chart = _resolveComponent("v-svg-icon-line-chart");
  var _component_v_side_modal_button = _resolveComponent("v-side-modal-button");
  var _component_v_svg_icon_percent = _resolveComponent("v-svg-icon-percent");
  var _component_v_svg_icon_calendar = _resolveComponent("v-svg-icon-calendar");
  var _component_v_svg_icon_calculator_with_books = _resolveComponent("v-svg-icon-calculator-with-books");
  var _component_v_svg_icon_money = _resolveComponent("v-svg-icon-money");
  var _component_v_svg_icon_folder = _resolveComponent("v-svg-icon-folder");
  var _component_v_svg_icon_note_with_clip = _resolveComponent("v-svg-icon-note-with-clip");
  var _component_v_svg_icon_question_in_circle = _resolveComponent("v-svg-icon-question-in-circle");
  var _component_v_side_modal_news_button = _resolveComponent("v-side-modal-news-button");
  var _component_v_svg_icon_circle_with_pen = _resolveComponent("v-svg-icon-circle-with-pen");
  var _component_v_side_modal_partners_card = _resolveComponent("v-side-modal-partners-card");
  var _component_v_svg_icon_calendar_with_books = _resolveComponent("v-svg-icon-calendar-with-books");
  return _openBlock(), _createElementBlock("div", null, [_createCommentVNode(" Overlay "), $data.isMenuModalVisible ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    id: "overlay",
    class: "overlay",
    onClick: _cache[0] || (_cache[0] = function () {
      return $options.closeMenuModal && $options.closeMenuModal.apply($options, arguments);
    })
  })) : _createCommentVNode("v-if", true), _createCommentVNode(" Side Modal "), $data.isMenuModalVisible ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_v_rounded_button, {
    link: $options.originUrl()
  }, null, 8 /* PROPS */, ["link"]), _createElementVNode("button", {
    class: "close-icon-modal",
    onClick: _cache[1] || (_cache[1] = function () {
      return $options.closeMenuModal && $options.closeMenuModal.apply($options, arguments);
    })
  }, [_createVNode(_component_v_svg_icon_cross, {
    class: "svg-icon-cross"
  })])])]), $data.isLoading ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_v_loading_spinner_with_text)])) : (_openBlock(), _createElementBlock("div", _hoisted_5, [_createCommentVNode(" Tabs "), _createElementVNode("div", _hoisted_6, [_createCommentVNode(" Hypoteční (HU) "), $options.showPartnersMethodology || $options.showPartnersMortgage ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass({
      'menu-tab': true,
      'menu-active-tab': $data.activeTab === 1,
      'menu-inactive-tab': $data.activeTab !== 1
    }),
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return $data.activeTab = 1;
    })
  }, [_createVNode(_component_v_svg_icon_three_houses, {
    class: "tab-icon icon-size"
  }), $options.locale === 'cs-CZ' ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toConsumableArray(_cache[5] || (_cache[5] = [_createElementVNode("span", {
    class: "bold"
  }, "Hypoteční", -1 /* CACHED */), _createElementVNode("br", null, null, -1 /* CACHED */), _createTextVNode(" úvěry ", -1 /* CACHED */)])))) : (_openBlock(), _createElementBlock("span", _hoisted_8, _toConsumableArray(_cache[6] || (_cache[6] = [_createElementVNode("span", {
    class: "bold"
  }, "Hypotekárne", -1 /* CACHED */), _createElementVNode("br", null, null, -1 /* CACHED */), _createTextVNode(" úvery ", -1 /* CACHED */)]))))], 2 /* CLASS */)) : _createCommentVNode("v-if", true), _createCommentVNode(" Spotřebitelské úvěry (SU) "), $options.showPartnersSu ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass({
      'menu-tab': true,
      'menu-active-tab': $data.activeTab === 2,
      'menu-inactive-tab': $data.activeTab !== 2
    }),
    onClick: _cache[3] || (_cache[3] = function ($event) {
      return $data.activeTab = 2;
    })
  }, [_createVNode(_component_v_svg_icon_house_with_car, {
    class: "tab-icon icon-size"
  }), _cache[7] || (_cache[7] = _createElementVNode("span", null, [_createElementVNode("span", {
    class: "bold"
  }, "Spotřebitelské"), _createTextVNode(" úvěry ")], -1 /* CACHED */))], 2 /* CLASS */)) : _createCommentVNode("v-if", true), _createCommentVNode(" Nezajištěné úvěry (NU) "), $options.showPartnersNu ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: _normalizeClass({
      'menu-tab': true,
      'menu-active-tab': $data.activeTab === 3,
      'menu-inactive-tab': $data.activeTab !== 3
    }),
    onClick: _cache[4] || (_cache[4] = function ($event) {
      return $data.activeTab = 3;
    })
  }, [_createVNode(_component_v_svg_icon_house_with_tree, {
    class: "tab-icon icon-size"
  }), _cache[8] || (_cache[8] = _createElementVNode("span", null, [_createElementVNode("span", {
    class: "bold"
  }, "Nezajištěné"), _createTextVNode(" úvěry ")], -1 /* CACHED */))], 2 /* CLASS */)) : _createCommentVNode("v-if", true)]), _createCommentVNode(" Tab Content "), _createElementVNode("div", _hoisted_9, [_createCommentVNode(" 1) Hypoteční (HU) "), $data.activeTab === 1 && $options.showPartnersMethodology ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [$options.showMortgageMethodology ? (_openBlock(), _createBlock(_component_v_side_modal_button, {
    key: 0,
    text: "Metodika",
    link: $options.locale === 'cs-CZ' ? $options.linkMetodikaHuCz : $options.linkMetodikaHuSk
  }, {
    icon: _withCtx(function () {
      return [_createVNode(_component_v_svg_icon_line_chart)];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["link"])) : _createCommentVNode("v-if", true), _createVNode(_component_v_side_modal_button, {
    text: $options.locale === 'cs-CZ' ? 'Nová kalkulace' : 'Nová ponuka',
    link: $options.linkKalkulaceHu
  }, {
    icon: _withCtx(function () {
      return [_createVNode(_component_v_svg_icon_percent)];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["text", "link"])]), $options.showPartnersMethodology ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_v_side_modal_button, {
    text: $options.locale === 'cs-CZ' ? 'Splátkový kalendář' : 'Splátkový kalendár',
    link: $options.linkRatesPayments
  }, {
    icon: _withCtx(function () {
      return [_createVNode(_component_v_svg_icon_calendar)];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["text", "link"]), _createVNode(_component_v_side_modal_button, {
    text: $options.locale === 'cs-CZ' ? 'Refinancování' : 'Refinancovanie',
    link: $options.linkRatesRefinance
  }, {
    icon: _withCtx(function () {
      return [_createVNode(_component_v_svg_icon_calculator_with_books)];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["text", "link"]), $options.locale === 'cs-CZ' ? (_openBlock(), _createBlock(_component_v_side_modal_button, {
    key: 0,
    text: "Účelně vynaložené náklady",
    link: $options.linkRatesSpentCosts
  }, {
    icon: _withCtx(function () {
      return [_createVNode(_component_v_svg_icon_money)];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["link"])) : _createCommentVNode("v-if", true)])) : _createCommentVNode("v-if", true), _createElementVNode("div", _hoisted_13, [$options.showPartnersMethodology ? (_openBlock(), _createBlock(_component_v_side_modal_button, {
    key: 0,
    text: $options.locale === 'cs-CZ' ? 'Uložené nabídky' : 'Uložené ponuky',
    link: $options.linkUlozeneKalkulaceHu
  }, {
    icon: _withCtx(function () {
      return [_createVNode(_component_v_svg_icon_folder)];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["text", "link"])) : _createCommentVNode("v-if", true), $options.locale === 'cs-CZ' && $options.showPartnersMortgage ? (_openBlock(), _createBlock(_component_v_side_modal_button, {
    key: 1,
    text: "Online žádosti",
    link: $options.linkOnlineZadostiHu
  }, {
    icon: _withCtx(function () {
      return [_createVNode(_component_v_svg_icon_note_with_clip)];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["link"])) : _createCommentVNode("v-if", true)]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createVNode(_component_v_side_modal_news_button, {
    text: "Návody",
    class: "left-button",
    locale: $options.locale
  }, {
    icon: _withCtx(function () {
      return [_createVNode(_component_v_svg_icon_question_in_circle)];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["locale"])]), _createVNode(_component_v_side_modal_news_button, {
    text: "Novinky",
    link: $options.linkNovinky,
    class: "right-button",
    locale: $options.locale
  }, {
    icon: _withCtx(function () {
      return [_createVNode(_component_v_svg_icon_circle_with_pen)];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["link", "locale"])]), _createCommentVNode(" Produktové karty (partners) "), _createVNode(_component_v_side_modal_partners_card, {
    title: $options.locale === 'cs-CZ' ? 'Produktové karty bank' : 'Produktové karty bánk',
    sources: "mortgage",
    companies: $data.partnersHu,
    externalBaseUrl: $props.initialData.externalBaseUrl,
    locale: $options.locale
  }, null, 8 /* PROPS */, ["title", "companies", "externalBaseUrl", "locale"])])) : _createCommentVNode("v-if", true), _createCommentVNode(" 2) Spotřebitelské úvěry (SU) "), $data.activeTab === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [$options.showPersonalLoanMethodology ? (_openBlock(), _createBlock(_component_v_side_modal_button, {
    key: 0,
    text: "Metodika",
    link: $options.linkMetodikaSu
  }, {
    icon: _withCtx(function () {
      return [_createVNode(_component_v_svg_icon_line_chart)];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["link"])) : _createCommentVNode("v-if", true), $options.getModuleInstance('PersonalLoan') ? (_openBlock(), _createBlock(_component_v_side_modal_button, {
    key: 1,
    text: "Nová kalkulace",
    link: $options.linkKalkulaceSu
  }, {
    icon: _withCtx(function () {
      return [_createVNode(_component_v_svg_icon_percent)];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["link"])) : _createCommentVNode("v-if", true)]), $options.getModuleInstance('PersonalLoan') ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createVNode(_component_v_side_modal_button, {
    text: "Splátkový kalendář",
    link: $options.linkSplatkovyKalendarSu
  }, {
    icon: _withCtx(function () {
      return [_createVNode(_component_v_svg_icon_calendar_with_books)];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["link"])])) : _createCommentVNode("v-if", true), _createCommentVNode(" Uložené nabídky SÚ → centrální stránka s předvybranou kategorií (mirror HÚ linkUlozeneKalkulaceHu). "), $options.getModuleInstance('PersonalLoan') ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createVNode(_component_v_side_modal_button, {
    text: "Uložené nabídky",
    link: $options.linkUlozeneNabidkySu
  }, {
    icon: _withCtx(function () {
      return [_createVNode(_component_v_svg_icon_folder)];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["link"])])) : _createCommentVNode("v-if", true), _createElementVNode("div", _hoisted_20, [_createVNode(_component_v_side_modal_news_button, {
    text: "Návody",
    videoUrl: "https://www.youtube.com/embed/HBe1T3vKpR0?si=Tsv3JCUlU_Fh9MPS",
    class: "left-button",
    locale: $options.locale
  }, {
    icon: _withCtx(function () {
      return [_createVNode(_component_v_svg_icon_question_in_circle)];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["locale"]), _createVNode(_component_v_side_modal_news_button, {
    text: "Novinky",
    link: $options.linkNovinky,
    class: "right-button",
    locale: $options.locale
  }, {
    icon: _withCtx(function () {
      return [_createVNode(_component_v_svg_icon_circle_with_pen)];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["link", "locale"])]), $options.getModuleInstance('PersonalLoan') ? (_openBlock(), _createBlock(_component_v_side_modal_partners_card, {
    key: 2,
    title: "Produktové karty bank",
    sources: "su",
    companies: $data.partnersSu,
    externalBaseUrl: $props.initialData.externalBaseUrl,
    locale: $options.locale
  }, null, 8 /* PROPS */, ["companies", "externalBaseUrl", "locale"])) : _createCommentVNode("v-if", true)])) : _createCommentVNode("v-if", true), _createCommentVNode(" 3) Nezajištěné úvěry (NU) "), $data.activeTab === 3 ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [$options.showBuildingMethodology ? (_openBlock(), _createBlock(_component_v_side_modal_button, {
    key: 0,
    text: "Metodika",
    link: $options.linkMetodikaNu
  }, {
    icon: _withCtx(function () {
      return [_createVNode(_component_v_svg_icon_line_chart)];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["link"])) : _createCommentVNode("v-if", true), $options.getModuleInstance('UnsecuredLoans') ? (_openBlock(), _createBlock(_component_v_side_modal_button, {
    key: 1,
    text: "Nová kalkulace",
    link: $options.linkKalkulaceNu
  }, {
    icon: _withCtx(function () {
      return [_createVNode(_component_v_svg_icon_percent)];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["link"])) : _createCommentVNode("v-if", true)]), $options.getModuleInstance('UnsecuredLoans') ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createVNode(_component_v_side_modal_button, {
    text: "Splátkový kalendář",
    link: $options.linkSplatkovyKalendarNu
  }, {
    icon: _withCtx(function () {
      return [_createVNode(_component_v_svg_icon_calendar_with_books)];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["link"])])) : _createCommentVNode("v-if", true), _createCommentVNode(" Uložené nabídky NÚ → centrální stránka s předvybranou kategorií (mirror HÚ linkUlozeneKalkulaceHu). "), $options.getModuleInstance('UnsecuredLoans') ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createVNode(_component_v_side_modal_button, {
    text: "Uložené nabídky",
    link: $options.linkUlozeneNabidkyNu
  }, {
    icon: _withCtx(function () {
      return [_createVNode(_component_v_svg_icon_folder)];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["link"])])) : _createCommentVNode("v-if", true), _createElementVNode("div", _hoisted_25, [_createVNode(_component_v_side_modal_news_button, {
    text: "Návody",
    videoUrl: "https://www.youtube.com/embed/NYHbpZKDjBk?si=WBspwAXXLwlOQxmM",
    class: "left-button",
    locale: $options.locale
  }, {
    icon: _withCtx(function () {
      return [_createVNode(_component_v_svg_icon_question_in_circle)];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["locale"]), _createVNode(_component_v_side_modal_news_button, {
    text: "Novinky",
    link: $options.linkNovinky,
    class: "right-button",
    locale: $options.locale
  }, {
    icon: _withCtx(function () {
      return [_createVNode(_component_v_svg_icon_circle_with_pen)];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["link", "locale"])]), $options.getModuleInstance('UnsecuredLoans') && $data.partnersNu.length > 0 ? (_openBlock(), _createBlock(_component_v_side_modal_partners_card, {
    key: 2,
    title: "Produktové karty stavebních spořitelen",
    sources: "building",
    companies: $data.partnersNu,
    externalBaseUrl: $props.initialData.externalBaseUrl,
    locale: $options.locale
  }, null, 8 /* PROPS */, ["companies", "externalBaseUrl", "locale"])) : _createCommentVNode("v-if", true)])) : _createCommentVNode("v-if", true)])]))])) : _createCommentVNode("v-if", true)]);
}